var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTrendingUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 12,
    viewBox: "0 0 21 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5713 0L16.8613 2.29L11.9813 7.17L7.98129 3.17L0.571289 10.59L1.98129 12L7.98129 6L11.9813 10L18.2813 3.71L20.5713 6V0H14.5713Z",
    fill: "#00B69B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrendingUp);
export default __webpack_public_path__ + "static/media/ic-trending-up.9a7206c392dab17678a29a20e3fd1f85.svg";
export { ForwardRef as ReactComponent };